import styled from "styled-components";

const Trash = styled.i.attrs({
  className: "fa fa-trash"
})``;

export default Trash;
